<div class="footer-wrapper">
  @if (footerData | async) {
    <div #mainFooter [innerHTML]="(footerData | async)?.htmlDescription | safeHtml" class="footer-main"></div>
  }
</div>
